import axios, { AxiosProgressEvent } from "axios";

import LocalFile from "models/LocalFile";

import { chunkGenerator } from "../utils/chunk";
import { getUploadSignedUrls } from "./signedUrl";

export const uploadFiles = async (
	files: LocalFile[],
	makeProgress?: (bytes: number, total?: number, id?: string) => void,
	signal?: AbortSignal,
) => {
	const signedUrls = await getUploadSignedUrls(
		files.map((file) => ({ filepath: file.filepath, contentType: file.file?.type })),
	);
	for (const chunk of chunkGenerator(files, 20))
		await Promise.all(
			chunk.map((file) => {
				const signedUrl = signedUrls[file.filepath];
				// Pre-checks
				if (!signedUrl) throw new Error(`Invalid signed url ${signedUrl} for file ${file.filepath}`);
				if (!file.file) return;
				// Save blob to corresponding signed url
				const headers: Record<string, string> = { "Content-Type": file.file.type };
				return axios.put(signedUrl, file.file, {
					headers,
					signal,
					onUploadProgress: (progressEvent: AxiosProgressEvent) =>
						makeProgress && makeProgress(progressEvent.loaded, progressEvent.total, file.filepath),
				});
			}),
		);
};
